import { LOCALE_CHANGED } from '../../constants'
import { actionLoggerLog } from '../../actions'
import { selectors as backendSelectors } from '../Backend'
import { actions as usersActions, selectors as usersSelectors } from '../Users'

export { launcherOpenProfilesDialog } from '../../launcherBackend/launcher-command'

export { default as Button } from '../../components/Button'
export { default as getTexts } from '../../store/localizer'

export const constants = {
    LOCALE_CHANGED,
}

export const actions = {
    log: actionLoggerLog,
    setUserProfile: (serverId, userId, profile) =>
        usersActions.setUserProfile(serverId, userId, profile),
}

export const selectors = {
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    getActiveServerProfiles: state => backendSelectors.getActiveServerProfiles(state),
    getActiveUserProfile: (state, userId) => usersSelectors.getActiveUserProfile(state, userId),
}



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/imports.js